export default __webpack_public_path__ + "static/media/IRM-logo.a4ba3593.png";